import StyledMaskedTextField from './styles';

import InputAdornment from '@material-ui/core/InputAdornment';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';

/**
 * Função Default
 * 
 * @param {boolean} onBlur
 * @param {string} children
 * @param {number} id 
 * @param {number} value
 * @param {string} label
 * @param {boolean} toolOptionsState
 * @param {boolean} lat
 * @returns Um modal com labels onde é possivel inserir lat e long fuso , e tambem
 * é possivel fazer upload de arquivos CSVe  outros detalhes
 */
export default ({
  onBlur,
  children,
  id,
  value,
  label,
  toolOptionsState,
  lat = true,
}) => {
  const [editable, setEditable] = useState(false);

  return (
    <div>
      {!editable ? (
        <span onDoubleClick={() => setEditable(true)}>{children}</span>
      ) : (
        <StyledMaskedTextField
          id={id}
          label={label}
          variant="outlined"
          size="small"
          value={value}
          mask={toolOptionsState.type.mask[lat ? 'lat' : 'lng']}
          placeholder={toolOptionsState.type.placeholder[lat ? 'lat' : 'lng']}
          initialActive={true}
          guide={false}
          autoFocus
          endAdornment={
            <InputAdornment position="end">
              {toolOptionsState.type.endAdornment}
            </InputAdornment>
          }
          onBlur={(e) => {
            onBlur(e.target.value);
            setEditable(false);
          }}
        />
      )}
    </div>
  );
};
